import React from 'react';
import { useTheme } from 'styled-components';
import { MoneyCard } from 'components/data-card';
import { transferPropTypes } from 'helpers/propTypes';

const Transfer = ({ transfer }) => {
  const theme = useTheme();

  return (
    <>
      <MoneyCard
        price={transfer?.IVA}
        label="IVA"
        primaryTextColor={theme.colors.dataCardDefaultTitleColor}
        secondaryTextColor={theme.colors.sideBarIconInactive}
      />
      <MoneyCard
        price={transfer?.IEPS}
        label="IEPS"
        primaryTextColor={theme.colors.dataCardDefaultTitleColor}
        secondaryTextColor={theme.colors.sideBarIconInactive}
      />
      <MoneyCard
        price={transfer?.TOTAL}
        label="Total de retenciones"
        primaryTextColor={theme.colors.dataCardPrimaryTitleColor}
        secondaryTextColor={theme.colors.sideBarIconInactive}
      />
    </>
  );
};

Transfer.propTypes = transferPropTypes;

export default Transfer;
